<template>
    <form @submit.prevent="handleSubmit" novalidate>
        <div class="form-group">
            <h3 class="wizard-title" v-html="parseNewlines(category.claim)"></h3>
        </div>

        <assessment-question
            :data="question"
            :score.sync="formData[question.resourceId].score"
            :notes.sync="formData[question.resourceId].notes"
            :disabled="disabled"
            v-for="question in questions"
            :key="question.id"
        />

        <div class="form-group" v-if="!disabled">
            <button class="btn btn-lg btn-secondary btn-space" type="button" :disabled="firstStep" @click.prevent="$emit('previous', formData)">zurück</button>
            <button class="btn btn-lg btn-success btn-space wizard-next" type="submit" v-if="lastStep">Assessment abschliessen</button>
            <button class="btn btn-lg btn-primary btn-space wizard-next" type="submit" v-else>weiter</button>
        </div>
    </form>
</template>

<script>
    import exam from '../../../../mixins/exam';
    import markup from '../../../../mixins/markup';

    import AssessmentQuestion from './Question';

    export default {
        mixins: [exam, markup],
        components: { AssessmentQuestion },

        data: () => ({
            category: null,
            questions: null,
        }),
    };
</script>
